import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { PointOfSale } from '../../order/waiting-notes/waitingnotes.component';
import { TranslateService } from '@ngx-translate/core';

interface UpdateTemplateResponse {
    data: {
        results: {
            app_id: string;
            device_id: string;
            result: string;
            status_code: number;
        }[];
    };
    success: boolean;
}

@Component({
    selector: 'change-device-affectation',
    templateUrl: './change-device-affectation.component.html',
})
export class ChangeDeviceAffectationComponent implements OnInit {
    deviceId = '';
    urlBase = environment.apiUrl; // Stocke l'url.
    deviceName = '';
    id_user = '';
    denominationPoS = '';
    loading = false;
    errorMessage = '';
    posList: PointOfSale[] = [];
    selectedPosDenomination: string | null = null;

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public translate: TranslateService,

    ) { }

    async ngOnInit(): Promise<void> {
        this.route.queryParams.subscribe(params => {
            this.deviceId = params['deviceId'] || '';
            this.deviceName = params['deviceName'] || '-';
            this.denominationPoS = params['devicePoS'] || '-';
            this.id_user = params['id_user'] || 0;
        });
        const pos = await this.getPointOfsaleById(this.id_user);
        if(pos) {
            this.posList = pos;
        }
    }

    onError(place: string, error: unknown): void {
        if (error instanceof Error) {
            console.error(place, ":", error.message);
        } else {
            console.error(place, ":", error);
        }
        // this.stopAutoRefresh();
    }

    async postBaseApi<T>(endpoint: string, param: Record<string, unknown> = {}): Promise<T> {
        try {
            const result = await this.http.post<T>(this.urlBase + endpoint, param, {
                headers: { "Content-Type": "application/json" }
            }).toPromise();
            return result as T;
        } catch (error) {
            this.onError(`POST ${endpoint}`, error);
            throw error;
        }
    }

    async getBaseApi<T>(endpoint: string, params: Record<string, unknown> = {}): Promise<T> {
        const queryParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined && value !== null)
                queryParams.set(key, String(value));
        }
        const url = `${this.urlBase}${endpoint}?${queryParams.toString()}`;
        try {
            const res = await this.http.get<T>(url).toPromise();
            return res as T;
        } catch (err) {
            this.onError('API error:', err);
            throw err;
        }
    }

    async getPointOfsaleById(posId: string): Promise<PointOfSale[]> {
        // const pos = await this.getBaseApi<PointOfSale>("custom/point_of_sale", { id_webshop: posId });
        const pos = await this.getBaseApi<PointOfSale[]>("custom/point_of_sale_by_user_id", { id_user: 87141 });
        if (!pos) {
            this.router.navigate(["/404", this.translate.instant('error404.noPof')], { skipLocationChange: true });
        }
        return pos;
    }

    async changeDeviceAffectation() {
        try {
            const body = {
                device_id: this.deviceId,
                device_name: this.deviceName,
                denomination_pos: this.selectedPosDenomination ,
                id_user: this.id_user,
            };
            const res = await this.postBaseApi<UpdateTemplateResponse>('update-device-affectation', body);
            if (res.success) {
                this.router.navigateByUrl('/seeMyConnectedDevices');
            } else {
                alert('⚠️ Le serveur a répondu sans succès.');
                console.warn('Réponse :', res);
            }
        } catch (err: any) {
            const message =
                err?.error?.error?.message ||
                err?.error?.message ||
                'Une erreur inconnue est survenue pendant la mise à jour.';
            console.error('❌ Erreur lors de l’envoi au backend :', err);
            alert(`❌ ${message}`);
        }
    }
}

